<script>
/**
 * Widget-stat component -- specify the widget title, image, value, subtext and color of subtext.
 */
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    value: {
      type: Number,
      default: ""
    },
    subText: {
      type: Number,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    popoverText: {
      type: String,
      default: ""
    }
  }
};
</script>

<template>
  <div class="card mini-stat bg-primary text-white">
    <div class="card-body">
      <div class="mb-4">
        <div class="float-left mini-stat-img mr-4">
          <img :src="`${image}`" alt />
        </div>
        <h5 class="font-size-16 text-uppercase mt-0 text-white-50">{{title}}</h5>
        <h4 class="font-weight-medium font-size-24">
          {{value}}
          <i v-if="subText>=0" class="mdi mdi-arrow-up text-success ml-2"></i>
          <i v-else class="mdi mdi-arrow-down text-success ml-2"></i>
          <i class="ti-help-alt" style="cursor: pointer;margin-left: 10px;font-size: 20px;" v-b-popover.hover.bottom="popoverText"></i>
        </h4>
        <div :class="`mini-stat-label bg-${color}`" style="top: 40px;">
          <p class="mb-0">{{subText}}%</p>
        </div>
      </div>
      <div class="pt-2">
        <div class="float-right">
          <a href="#" class="text-white-50">
            <i class="mdi mdi-arrow-right h5"></i>
          </a>
        </div>
        <p class="text-white-50 mb-0 mt-1">Since last month</p>
      </div>
    </div>
  </div>
</template>